// C7 reste (recette SITADEL 11/08) : en base 100, une série dont toute la fenêtre est à
// zéro n'a pas de première valeur non nulle pour s'indexer — chaque point devenait null
// et la courbe disparaissait EN SILENCE du graphe. Indexer une série nulle n'a pas de
// sens mathématique, et restaurer l'ancienne courbe (qui indexait des actes, pas des
// logements) mesurerait une autre grandeur : l'état vide se DIT au lieu de se maquiller.
//
// Détection POST-HOC sur les datasets effectivement rendus — `data` toute nulle mais
// `abs` porteur d'au moins une mesure = série réelle que la base 100 ne peut pas tracer.
// Une série sans aucune mesure (`abs` tout null ou absent) n'est PAS flaguée : c'est une
// absence de donnée, signalée par ailleurs (« indisponible »), pas un zéro réel.
export function serieNonIndexable(ds: { data: (number | null)[]; abs?: (number | null)[] }): boolean {
  return !!ds.abs?.some(v => v !== null) && ds.data.every(v => v === null)
}
